"use strict";var m=Object.defineProperty;var p=Object.getOwnPropertyDescriptor;var r=(o,l,e,i)=>{for(var t=i>1?void 0:i?p(l,e):l,a=o.length-1,c;a>=0;a--)(c=o[a])&&(t=(i?c(l,e,t):c(t))||t);return i&&t&&m(l,e,t),t};import{baseStyles as h,CiscoUElement as d,html as s,nothing as n}from"@cisco-u/base";import{property as u}from"@cisco-u/base/src/decorators.js";import"@cisco-u/logo/cu-logo.js";import"@cisco-u/links/cu-links.js";import"@cisco-u/collapsible/cu-collapsible.js";import"@cisco-u/social-buttons/cu-social-buttons.js";import f from"./footer.css.js";export class Footer extends d{constructor(){super(...arguments);this.usedExternal=!1;this.auth=!1;this.unrestricted=!1;this._educationLinks={type:"Learn",list:[{name:"Explore catalog",url:"/explore",external:!1},{name:"Learning Paths",url:"/paths",external:!1},{name:"Courses",url:"/courses",external:!1},{name:"Challenges",url:"/challenges",external:!1},{name:"Practice Exams",url:"/exams",external:!1},{name:"Instructor-Led",url:"/instructorled",external:!1},{name:"Tutorials",url:"/tutorials",external:!1},{name:"Videos",url:"/videos",external:!1}]};this._certificationLinks={type:"Certifications",list:[{name:"Get Certified",url:"https://www.cisco.com/c/en/us/training-events/training-certifications/certifications.html#~certifications",external:!0},{name:"Continuing Education",url:"https://www.cisco.com/c/en/us/training-events/training-certifications/training/continuing-education-program.html",external:!0}]};this._communityLinks={type:"Community",list:[{name:"Communities",url:"/community-landing-page",external:!1},{name:"Events",url:"/events",external:!1},{name:"Podcasts",url:"/podcasts",external:!1},{name:"Snack Minute Playlist",url:"https://www.youtube.com/playlist?list=PL2AuQ_ZjCjsq_dipCVvUS7enTwk4_P7n5",external:!0}]};this._viewPlansLinks={type:"Plans",list:[{name:"Subscriptions",url:"/subscription",external:!1},{name:"Learning Credits",url:"https://www.cisco.com/c/en/us/training-events/training-certifications/training/learning-credits.html",external:!0}]};this._helpLinks={type:"Help",list:[{name:"Cisco U. Support",url:"https://servicedesk.certsite.net/jira/servicedesk/customer/portal/3",external:!0},{name:"FAQs",url:"https://confluence.certsite.net/confluence/pages/viewpage.action?pageId=102639512",external:!0}]};this._socialIcons=[{name:"youtube",url:"https://www.youtube.com/@CiscoUtube?sub_confirmation=1",external:!0},{name:"facebook",url:"https://www.facebook.com/learningatcisco",external:!0},{name:"twitter",url:"https://twitter.com/LearningatCisco",external:!0},{name:"instagram",url:"https://www.instagram.com/learningatcisco/",external:!0},{name:"linkedin",url:"https://www.linkedin.com/showcase/cisco_training_and_certification",external:!0}];this._footnoteLinks=[{name:"Terms & Conditions",url:"https://www.cisco.com/c/en/us/about/legal/terms-conditions.html",external:!0},{name:"Privacy Policy",url:"https://www.cisco.com/c/en/us/about/legal/privacy-full.html",external:!0},{name:"Cookie Policy",url:"https://www.cisco.com/c/en/us/about/legal/privacy-full.html#cookies",external:!0},{name:"Accessibility at Cisco",url:"https://www.cisco.com/c/en/us/about/accessibility/q-a.html#%7Eaccessibility-faq",external:!0},{name:"Trademarks",url:"https://www.cisco.com/c/en/us/about/legal/trademarks.html",external:!0}]}static get styles(){return[h,f]}render(){return s`
      <footer class="footer">
        <div class="flex footer-main">
          <div class="cisco-u-logo">
            <a title="Cisco U Home" href="https://u.cisco.com/">
              <cu-logo type="cisco-u" label="Cisco U Home"></cu-logo>
            </a>
          </div>

          <div class="collapsibles">
            ${this.auth?this._renderForYou():n}
            <cu-collapsible btnText="${this._educationLinks.type}">
              ${this._linkList(this._educationLinks,!0)}
            </cu-collapsible>

            <cu-collapsible btnText="${this._certificationLinks.type}">
              ${this._linkList(this._certificationLinks,!0)}
            </cu-collapsible>

            <cu-collapsible btnText="${this._communityLinks.type}">
              ${this._linkList(this._communityLinks,!0)}
            </cu-collapsible>

            <cu-collapsible btnText="${this._viewPlansLinks.type}">
              ${this._linkList(this._viewPlansLinks,!0)}
            </cu-collapsible>

            <cu-collapsible btnText="${this._helpLinks.type}">
              ${this._linkList(this._helpLinks,!0)}
            </cu-collapsible>
          </div>

          <div class="footer-links">
            ${this._linkList(this._educationLinks,!1)}
            ${this._linkList(this._certificationLinks,!1)}
            ${this._linkList(this._communityLinks,!1)}
            ${this._linkList(this._viewPlansLinks,!1)}
            ${this._linkList(this._helpLinks,!1)}

            <div class="social">
              <div class="list-header stay-connected">Connect</div>
              <ul class="flex no-list social-list">
                ${this._socialIcons.map(e=>s`
                    <li>
                      <cu-social-buttons
                        type=${e.name}
                        href=${e.url}
                        iconStyle="dark"
                        label="Go to ${e.name}"
                        external=${e.external||n}
                      ></cu-social-buttons>
                    </li>
                  `)}
              </ul>
            </div>
          </div>
        </div>

        <div class="footer-note">
          <div class="copy-text copy-text-lg">
            &copy; ${this._copyrightDate(this._date)}
          </div>
          <div class="flex footer-info">
            <ul class="flex no-list footnote-list">
              ${this._footnoteLinks.map(e=>s`
                  <li class="footnote-link">
                    <cu-links
                      text=${e.name}
                      url=${e.url}
                      dark="true"
                      noUnderline="true"
                      size="small"
                      external=${e.external||n}
                      @click=${i=>this._handleLinkClick(i,e)}
                    ></cu-links>
                  </li>
                `)}
            </ul>
          </div>

          <div class="footer-copy">
            <div class="cisco-logo"><cu-logo width="2.8125rem"></cu-logo></div>

            <div class="copy-text copy-text-sm">
              &copy; ${this._copyrightDate(this._date)}
            </div>
          </div>
        </div>
      </footer>
    `}_linkList(e,i){return this.auth&&e.type==="Learn"&&!i&&e.list.push({name:"For You",url:"/for-you",external:!1}),s`
      <ul class="no-list link-list" slot=${i?"content":n}>
        ${i?n:s`<li class="list-header">${e.type}</li>`}
        ${e.list.map(t=>s`
            <li class="list-item">
              <cu-links
                text=${t.name}
                url=${this._externalUserLink(t.external)+t.url}
                dark="true"
                noUnderline="true"
                external=${t.external||n}
                @click=${a=>this._handleLinkClick(a,t)}
              ></cu-links>
            </li>
          `)}
      </ul>
    `}_renderForYou(){return s` <div class="collapsible">
      <button
        @click=${e=>this._handleLinkClick(e,"/for-you")}
        type="button"
        class="collapsible-btn"
      >
        <a href="/for-you">
          For You
          <cu-icon-chevron-right size="m"></cu-icon-chevron-right>
        </a>
      </button>
    </div>`}_handleLinkClick(e,i){this.dispatchEvent(new CustomEvent("cu-footer-link",{detail:{event:e,...i},bubbles:!0,composed:!0}))}get _date(){return new Date().getFullYear()}_copyrightDate(e){return s`${e} Cisco Systems, Inc.`}_externalUserLink(e){return!e&&this.usedExternal?"https://u.cisco.com":""}}r([u({type:Boolean,reflect:!0})],Footer.prototype,"usedExternal",2),r([u({type:Boolean,reflect:!0})],Footer.prototype,"auth",2),r([u({type:Boolean,reflect:!0})],Footer.prototype,"unrestricted",2);
//# sourceMappingURL=Footer.js.map
